<template>
  <van-dialog
    v-model="dialogVisible"
    :show-confirm-button="false"
    width="375px"
    :close-on-click-overlay="true"
  >
    <div class="coupon-container">
      <div class="coupon-block-bg">
        <div class="coupon-info">
          <div class="coupon-amount">
            <div class="coupon-amount-info">
              <span>¥</span>
              <span>{{couponInfo.amount}}</span>
            </div>
            <div class="use-desc">
              <h1>满{{couponInfo.enableAmount}}元使用</h1>
              <span class="tag">{{
                couponInfo.classify | couponClassifyMaps
              }}</span>
            </div>
          </div>
          <div class="type-use">
            <div class="type-name">{{ couponInfo.classify | couponTypeMaps }}</div>
          </div>
        </div>
        <img src="@/assets/images/coupon-model-bg1.png" alt="" />
        <img src="@/assets/images/coupon-model-bg2.png" alt="" />
      </div>
      <img
        class="coupon-box-bg"
        src="@/assets/images/coupon-model-bg.png"
        alt=""
      />
      <div @click="gotoRecharge" class="coupon-btn">立即使用</div>
      <img
        @click="dialogVisible = false"
        class="close"
        src="@/assets/images/coupon-model-close.png"
        alt=""
      />
    </div>
  </van-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    couponAmount: {
        type: Number,
        default: 3
    },
    couponInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {};
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value;
      },

      set(val) {
        this.$emit("input", val);
      },
    }
  },
  filters: {
    couponTypeMaps(val) {
      if (val == "COMMON") {
        return "通用券";
      }
      if (val == "UNIVERSAL") {
        return "万能券";
      }
      if (val == "CONTINUE_CHARGE") {
        return "续充券";
      }
      if (val == "FIRST_CHARGE") {
        return "首充券";
      }
    },
    couponClassifyMaps(val) {
      
      if (val == "COMMON") {
        return "全类别通用";
      }
      if (val == "UNIVERSAL") {
        return "全平台可用";
      }
      if (val == "CONTINUE_CHARGE") {
        return "仅限续充使用";
      }
      if (val == "FIRST_CHARGE") {
        return "仅限首充使用";
      }
    },
  },
  methods: {
    gotoRecharge() {
      this.$router.push({ path: "/recharge", query: { page: "quick" } });
    },
  },
};
</script>

<style lang="scss" scoped>
.coupon-container {
  height: 700px;
  .coupon-box-bg {
    width: 100%;
    height: 558px;
    position: relative;
  }
  .coupon-block-bg {
    position: absolute;
    left: 166px;
    top: 123px;
    width: 400px;
    height: 125px;
    background: #ffffff;
    border-radius: 8px;
    display: flex;
    align-items: center;
    z-index: 2;
    justify-content: center;
    img {
      width: 260px;
      height: 111px;

      &:last-child {
        width: 126px;
      }
    }

    .coupon-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: absolute;
      left: 24px;

      .coupon-amount {
        display: flex;
        align-items: flex-start;
        width: 250px;

        .coupon-amount-info {
          display: flex;
          align-items: flex-start;
          margin-right: 8px;

          span {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 28px;
            color: #ffffff;
            line-height: 60px;

            &:last-child {
              font-family: PingFangSC, PingFang SC;
              font-weight: 600;
              font-size: 52px;
              color: #ffffff;
              line-height: 70px;
            }
          }
        }
        .use-desc {
          h1 {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 28px;
            color: #ffffff;
            line-height: 56px;
          }
          span {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 20px;
            color: #ffffff;
            line-height: 33px;
            display: block;
            opacity: 0.5;
          }
        }
      }
      .type-use {
        text-align: center;
      }
      .type-name {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 30px;
        color: #ffffff;
        width: 120px;
      }
    }
  }
  .coupon-btn {
    background: url(~@/assets/images/coupon-model-btn.png);
    background-size: 100% 100%;
    width: 337px;
    height: 120px;
    font-family: PingFang SC;
    font-weight: 600;
    font-size: 40px;
    color: #bc4d02;
    line-height: 120px;
    text-align: center;
    position: absolute;
    top: 394px;
    left: 194px;
  }
  .close {
    width: 60px;
    height: 136px;
    position: absolute;
    left: 345px;
    top: 500px;
  }
}
.van-dialog {
  background: transparent;
}
</style>


// WEBPACK FOOTER //
// src/components/CouponDialog.vue